var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right-sidebar" }, [
    _c("div", { staticClass: "slimscrollright" }, [
      _c("div", { staticClass: "rpanel-title" }, [
        _vm._v(
          " \n            " +
            _vm._s(_vm.trans("general.help")) +
            " \n            "
        ),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "r-panel-body" }, [
        _vm.content
          ? _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "loading" }, [
              _c("img", { attrs: { src: "/images/loading.gif" } })
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "btn btn-danger btn-sm right-sidebar-toggle pull-right m-r-10"
      },
      [_c("i", { staticClass: "fas fa-times" })]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-167546d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-167546d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/right-panel.vue
// module id = 504
// module chunks = 376